import React, {FC} from 'react'
import {UsersListWrapper} from './users-list/UsersList'

const UsersList: FC = () => {
  return (
    <>
      <UsersListWrapper />
    </>
  )
}

export default UsersList
